import { api } from "./base.api.ts";

export const getChatListing = async (role: number, userId: number) => {
  const idParameter = role === 1 ? "teacher_id" : "user_id"
  const url = userId ? `getChatListing/${role}?${idParameter}=${userId}` : `getChatListing/${role}`
  const res = await api.get(url);
  return res.data;
};
